import React, { createContext, useState } from 'react';
import { Grid } from 'components/layout/Grid';
import { Brikk } from 'components/Brikk';
import { IntlPageTitle } from 'components/intl/IntlPageTitle';
import { ModalIntro } from 'components/layout/ModalIntro';
import userAdminSrc from 'assets/media/user-admin.png';
// import { ProceedButton } from 'components/form-elements/buttons/ProceedButton';
import { ShouldRender } from '../../../../../ShouldRender';
// import styles from './styles.module.scss';
// eslint-disable-next-line import/no-cycle
import { UsersList } from './components/Users/components/UsersList';
// eslint-disable-next-line import/no-cycle
import { UserForm } from './components/User/components/UserForm';
// eslint-disable-next-line import/no-cycle
import { AddUserForm } from './components/User/components/AddUserForm';
// eslint-disable-next-line import/no-cycle
import { ManageService } from './components/ManageService/ManageService';

export const UserAdministrationModalContext = createContext(null);

export const UserAdministrationModal = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [service, setService] = useState(null);
  const [isAddingUser, setIsAddingUser] = useState(false);

  return (
    <UserAdministrationModalContext.Provider
      value={{ selectedUser, setSelectedUser, service, setService, isAddingUser, setIsAddingUser }}
    >
      <Grid brikkLayout>
        <IntlPageTitle intlTitle="userAdminBrikk" />

        <Grid.Column>
          <Brikk.Heading
            main
            heading="userAdminBrikk"
          >
            <ModalIntro>
              <ModalIntro.Image
                src={userAdminSrc}
                alt="User admin"
              />

              <ModalIntro.Text intl="userAdminDescription" />
            </ModalIntro>
          </Brikk.Heading>
            
          {/* <ProceedButton className={styles.button}>
            <ProceedButton.Button
              size={14}
              intl="goToDocuments"
            />
            <ProceedButton.SignIn />
          </ProceedButton> */}
       
        </Grid.Column>
        
        <Grid.Column>
          <UsersList />
        </Grid.Column>

        <ShouldRender condition={!service && !isAddingUser}>
          <Grid.Column noOverflow>
            <UserForm />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={!service && isAddingUser}>
          <Grid.Column noOverflow>
            <AddUserForm />
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={service}>
          <Grid.Column>
            <ManageService />
          </Grid.Column>  
        </ShouldRender>
      </Grid>
    </UserAdministrationModalContext.Provider>
  );
};
